export const TaskRequestStatuses = {
  ACCEPTED: 'Aceptada',
  REJECTED: 'Rechazada',
  PENDING: 'Pendiente',
}

// export const TaskRequestStatusesFilterOptions = { ...TaskRequestStatuses, ACTIVE: 'No rechazadas' }

export const TaskRequestStatusesColor = {
  ACCEPTED: '#0B5ED7',
  REJECTED: '#BB2D3B',
  PENDING: '#808080',
}